// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getPartnersCategoryJobs() {
            const response = await axios.get(`${MAIN_API}/api/partner-category-job`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
    },
    getters: {
    }
}
